import * as d3 from 'd3';

import { Log } from '../../../../models';
import { colorScale } from '../../shared/logsColorScale';

export function mostFrequentMessages(logs: Log[], maxCount = 50) {
    const byMessage = d3.nest<Log>()
        .key(d => d.file)
        .key(d => d.level)
        .key(d => d.message)
        .entries(logs);
    const tableByMessage = [].concat(...byMessage.map(byFile => {
        return [].concat(...byFile.values.map(
            (byLevel: { key: string, values: { key: string, values: Log[] }[] }) => {
                return [].concat(...byLevel.values.map(bm => {
                    return {
                        file: byFile.key,
                        level: byLevel.key,
                        message: bm.key,
                        count: bm.values.length,
                        color: colorScale(byLevel.key)
                    };
                }));
            }
        ));
    })
    )
        .sort((a, b) => a.count < b.count ? 1 : -1)
        .slice(0, maxCount);
    return tableByMessage;
}